// Mock data for AivoryEMS UI prototype.
// const API_BASE = typeof window !== "undefined" ? "" : "http://localhost:8001";

import { API_BASE } from "./utils";

export let events = [
  {
    id: "evt_001",
    slug: "stride-2026",
    title: "Stride / 2026",
    subtitle: "The B2B Operators' Conference",
    venue: "Pier 17, New York",
    timezone: "America/New_York",
    startDate: "2026-04-14",
    endDate: "2026-04-16",
    capacity: 4200,
    registered: 3128,
    checkedIn: 0,
    revenue: 487200,
    status: "Live",
    accent: "#FF5608",
    cover: "https://images.pexels.com/photos/11329863/pexels-photo-11329863.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "evt_002",
    slug: "ledger-summit",
    title: "Ledger Summit",
    subtitle: "Finance × Engineering Leaders",
    venue: "Excel London",
    timezone: "Europe/London",
    startDate: "2026-05-22",
    endDate: "2026-05-23",
    capacity: 1800,
    registered: 1142,
    checkedIn: 0,
    revenue: 218400,
    status: "Selling",
    accent: "#E25D3A",
    cover: "https://images.pexels.com/photos/13963614/pexels-photo-13963614.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "evt_003",
    slug: "northbound",
    title: "Northbound",
    subtitle: "Climate-Tech Founders Forum",
    venue: "Reykjavík Harpa",
    timezone: "Atlantic/Reykjavik",
    startDate: "2026-06-09",
    endDate: "2026-06-11",
    capacity: 900,
    registered: 412,
    checkedIn: 0,
    revenue: 98300,
    status: "Selling",
    accent: "#60A5FA",
    cover: "https://images.unsplash.com/photo-1762009365851-c5b5b1aae3b9?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "evt_004",
    slug: "atlas-2025",
    title: "Atlas / 2025",
    subtitle: "Enterprise Architecture",
    venue: "Singapore Suntec",
    timezone: "Asia/Singapore",
    startDate: "2025-11-04",
    endDate: "2025-11-06",
    capacity: 2400,
    registered: 2204,
    checkedIn: 2138,
    revenue: 612400,
    status: "Concluded",
    accent: "#A1A1AA",
    cover: "https://images.pexels.com/photos/15166530/pexels-photo-15166530.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export let kpis = [
  { label: "Total Registrations", value: 6886, delta: "+12.4%", trend: "up" },
  { label: "Net Revenue (USD)", value: 1416300, prefix: "$", delta: "+8.1%", trend: "up" },
  { label: "Conversion Rate", value: 34.6, suffix: "%", delta: "+2.1pp", trend: "up" },
  { label: "Onsite Throughput / hr", value: 612, delta: "Peak 14:00", trend: "flat" },
];

export let registrationsSeries = [
  { d: "Mar 04", v: 41 }, { d: "Mar 05", v: 64 }, { d: "Mar 06", v: 72 },
  { d: "Mar 07", v: 58 }, { d: "Mar 08", v: 91 }, { d: "Mar 09", v: 142 },
  { d: "Mar 10", v: 168 }, { d: "Mar 11", v: 122 }, { d: "Mar 12", v: 134 },
  { d: "Mar 13", v: 188 }, { d: "Mar 14", v: 232 }, { d: "Mar 15", v: 261 },
  { d: "Mar 16", v: 244 }, { d: "Mar 17", v: 298 }, { d: "Mar 18", v: 312 },
  { d: "Mar 19", v: 342 }, { d: "Mar 20", v: 401 }, { d: "Mar 21", v: 386 },
];

export let funnel = [
  { label: "Landing visits", value: 48230 },
  { label: "Form started", value: 18406 },
  { label: "Form completed", value: 9821 },
  { label: "Paid", value: 6886 },
];

export let ticketTiers = [
  { id: "early", name: "Early Bird", price: 449, sold: 1200, quota: 1200, status: "Sold out", window: "Closed" },
  { id: "regular", name: "Regular", price: 699, sold: 1820, quota: 2400, status: "Selling", window: "Now → Apr 10" },
  { id: "vip", name: "VIP — Operators Lounge", price: 1899, sold: 108, quota: 250, status: "Selling", window: "Now → Apr 12" },
  { id: "team", name: "Team of 5", price: 2999, sold: 36, quota: 100, status: "Selling", window: "Now → Apr 10" },
];

export let addOns = [
  { id: "wk1", name: "Workshop · Founder-led GTM", price: 199, sold: 312 },
  { id: "wk2", name: "Workshop · AI Ops Deep-Dive", price: 199, sold: 280 },
  { id: "din", name: "Speakers Dinner", price: 149, sold: 122 },
];

export let sessions = [
  { id: "s1", title: "Opening Keynote — The Operators' Decade", room: "Hall A", time: "Apr 14 · 09:30", capacity: 2000, registered: 1942 },
  { id: "s2", title: "Designing for Compounding Distribution", room: "Hall B", time: "Apr 14 · 11:15", capacity: 600, registered: 588 },
  { id: "s3", title: "Workshop · AI Ops Deep-Dive", room: "Studio 2", time: "Apr 14 · 14:00", capacity: 120, registered: 120 },
  { id: "s4", title: "Panel · The CFO Stack in 2026", room: "Hall A", time: "Apr 15 · 10:00", capacity: 2000, registered: 1422 },
  { id: "s5", title: "Fireside · Building in the Open", room: "Hall C", time: "Apr 15 · 15:30", capacity: 800, registered: 712 },
];

export let attendees = [
  { id: "a1", name: "Yasmin Park", email: "yasmin@northwind.io", company: "Northwind", role: "Head of Ops", ticket: "VIP", status: "Registered", checkin: null, country: "US" },
  { id: "a2", name: "Tomás Rivera", email: "tom@cassiopeia.dev", company: "Cassiopeia", role: "CTO", ticket: "Regular", status: "Paid", checkin: null, country: "MX" },
  { id: "a3", name: "Aïsha Lefèvre", email: "a.lefevre@meridienlabs.fr", company: "Meridien Labs", role: "Product Lead", ticket: "Early Bird", status: "Paid", checkin: null, country: "FR" },
  { id: "a4", name: "Devansh Iyer", email: "devansh@quill.ai", company: "Quill", role: "Founder", ticket: "VIP", status: "Paid", checkin: null, country: "IN" },
  { id: "a5", name: "Mira Lindqvist", email: "mira@halsa.co", company: "Halsa", role: "Head of People", ticket: "Regular", status: "Pending", checkin: null, country: "SE" },
  { id: "a6", name: "Kenji Watanabe", email: "kenji@orbis.jp", company: "Orbis", role: "VP Engineering", ticket: "Team of 5", status: "Paid", checkin: null, country: "JP" },
  { id: "a7", name: "Rosa Okafor", email: "rosa@vellum.studio", company: "Vellum Studio", role: "Designer", ticket: "Regular", status: "Refunded", checkin: null, country: "NG" },
  { id: "a8", name: "Lior Cohen", email: "lior@stratus.security", company: "Stratus", role: "CISO", ticket: "VIP", status: "Paid", checkin: null, country: "IL" },
  { id: "a9", name: "Beatriz Almeida", email: "bea@altaport.pt", company: "Altaport", role: "Marketing", ticket: "Regular", status: "Paid", checkin: null, country: "PT" },
  { id: "a10", name: "Henrik Sørensen", email: "h.sorensen@kompas.dk", company: "Kompas", role: "Strategy", ticket: "Early Bird", status: "Paid", checkin: null, country: "DK" },
];

export let checkInFeed = [
  { id: 1, name: "Devansh Iyer", company: "Quill", ticket: "VIP", time: "14:02:11", gate: "Gate A" },
  { id: 2, name: "Yasmin Park", company: "Northwind", ticket: "VIP", time: "14:01:52", gate: "Gate A" },
  { id: 3, name: "Mira Lindqvist", company: "Halsa", ticket: "Regular", time: "14:01:40", gate: "Gate B" },
  { id: 4, name: "Lior Cohen", company: "Stratus", ticket: "VIP", time: "14:01:22", gate: "Gate A" },
  { id: 5, name: "Beatriz Almeida", company: "Altaport", ticket: "Regular", time: "14:00:58", gate: "Gate C" },
  { id: 6, name: "Tomás Rivera", company: "Cassiopeia", ticket: "Regular", time: "14:00:31", gate: "Gate B" },
];

export let throughputSeries = Array.from({ length: 24 }, (_, i) => ({
  hr: `${String(i).padStart(2, "0")}:00`,
  v: Math.max(0, Math.round(380 * Math.exp(-Math.pow((i - 14) / 4.5, 2)) + (i > 8 && i < 19 ? 60 : 0))),
}));

export let campaigns = [
  { id: "c1", name: "Early Bird — Final 48h", segment: "Lead list · Tier-1", scheduled: "Mar 12 · 09:00", sent: 12842, opens: 0.46, clicks: 0.18, status: "Sent" },
  { id: "c2", name: "Speakers Drop #2", segment: "Past attendees 2024-25", scheduled: "Mar 21 · 15:00", sent: 8420, opens: 0.51, clicks: 0.22, status: "Sent" },
  { id: "c3", name: "Workshop upsell", segment: "Regular ticket holders", scheduled: "Apr 02 · 10:00", sent: 0, opens: 0, clicks: 0, status: "Scheduled" },
  { id: "c4", name: "T-7 reminder", segment: "All confirmed", scheduled: "Apr 07 · 08:00", sent: 0, opens: 0, clicks: 0, status: "Draft" },
];

export let auditLog = [
  { id: 1, actor: "ana@aivory.io", action: "Refund issued", target: "Order #18204 · $699.00", ts: "2026-03-21 14:22 UTC" },
  { id: 2, actor: "ben@aivory.io", action: "Role change", target: "marc@aivory.io → Marketing", ts: "2026-03-21 11:08 UTC" },
  { id: 3, actor: "ana@aivory.io", action: "Ticket edit", target: "VIP price 1799 → 1899", ts: "2026-03-20 18:40 UTC" },
  { id: 4, actor: "ana@aivory.io", action: "Capacity change", target: "Hall A · 1800 → 2000", ts: "2026-03-19 09:55 UTC" },
  { id: 5, actor: "system", action: "Webhook retry", target: "Stripe · evt_1NXk... · success", ts: "2026-03-18 22:01 UTC" },
];

export let team = [
  { name: "Ana Reyes", email: "ana@aivory.io", role: "Owner", initials: "AR" },
  { name: "Ben Carter", email: "ben@aivory.io", role: "Admin", initials: "BC" },
  { name: "Marc Iqbal", email: "marc@aivory.io", role: "Marketing", initials: "MI" },
  { name: "Soraya Bello", email: "soraya@aivory.io", role: "Onsite Staff", initials: "SB" },
  { name: "Henrik Sørensen", email: "henrik@aivory.io", role: "Finance", initials: "HS" },
];

export let formFields = [
  { id: "f1", type: "text", label: "Full name", required: true },
  { id: "f2", type: "email", label: "Work email", required: true },
  { id: "f3", type: "text", label: "Company", required: true },
  { id: "f4", type: "select", label: "Role", required: true, options: ["Founder/CEO", "Engineering", "Product", "Design", "Operations", "Other"] },
  { id: "f5", type: "select", label: "Company size", required: false, options: ["1–10", "11–50", "51–200", "201–1000", "1000+"] },
  { id: "f6", type: "checkbox", label: "I'd like marketing updates", required: false },
];

export let fieldLibrary = [
  { type: "short_answer", label: "Short answer" },
  { type: "long_answer", label: "Long answer" },
  { type: "paragraph", label: "Paragraph text" },
  { type: "email", label: "Email" },
  { type: "phone", label: "Phone number" },
  { type: "number", label: "Number" },
  { type: "url", label: "Website URL" },
  { type: "date", label: "Date" },
  { type: "time", label: "Time" },
  { type: "datetime", label: "Date & time" },
  { type: "select", label: "Single select" },
  { type: "dropdown", label: "Dropdown" },
  { type: "multiselect", label: "Multi select" },
  { type: "radio", label: "Multiple choice (single)" },
  { type: "checkbox_group", label: "Multiple choice (multi)" },
  { type: "checkbox", label: "Checkbox" },
  { type: "yes_no", label: "Yes/No" },
  { type: "linear_scale", label: "Linear scale" },
  { type: "rating", label: "Rating" },
  { type: "nps", label: "Net promoter score (0-10)" },
  { type: "address", label: "Address" },
  { type: "country", label: "Country" },
  { type: "consent", label: "Consent / declaration" },
  { type: "section", label: "Section heading" },
  { type: "hidden", label: "Hidden field" },
  { type: "file", label: "File upload" },
];

export let sponsors = ["NORTHWIND", "QUILL", "ORBIS", "MERIDIEN", "VELLUM", "STRATUS", "HALSA", "KOMPAS", "ALTAPORT"];

export const findEvent = (id) => events.find((e) => e.id === id || e.slug === id) || events[0];
export const findEventOrNull = (id) => events.find((e) => e.id === id || e.slug === id) || null;

export function hydrateMockData(data = {}) {
  events = data.events ?? events;
  kpis = data.kpis ?? kpis;
  registrationsSeries = data.registrationsSeries ?? registrationsSeries;
  funnel = data.funnel ?? funnel;
  ticketTiers = data.ticketTiers ?? ticketTiers;
  addOns = data.addOns ?? addOns;
  sessions = data.sessions ?? sessions;
  attendees = data.attendees ?? attendees;
  checkInFeed = data.checkInFeed ?? checkInFeed;
  throughputSeries = data.throughputSeries ?? throughputSeries;
  campaigns = data.campaigns ?? campaigns;
  auditLog = data.auditLog ?? auditLog;
  team = data.team ?? team;
  formFields = data.formFields ?? formFields;
  fieldLibrary = data.fieldLibrary ?? fieldLibrary;
  sponsors = data.sponsors ?? sponsors;
}

export async function bootstrapMockData() {
  const res = await fetch(`${API_BASE}/api/bootstrap-data`);
  if (!res.ok) throw new Error(`Failed to bootstrap data (${res.status})`);
  const payload = await res.json();
  hydrateMockData(payload?.data ?? {});
  return payload?.data ?? {};
}
